import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ConversationInfo } from '../types/ConversationInfo';

interface ConversationsState {
  currentConversationId: string | null;
  conversationList: ConversationInfo[];
  conversationListLoaded: boolean;
}

const initialState: ConversationsState = {
  currentConversationId: null,
  conversationList: [],
  conversationListLoaded: false,
};

const conversationsSlice = createSlice({
  name: 'conversations',
  initialState,
  reducers: {
    setCurrentConversationId: (state, action: PayloadAction<string | null>) => {
      state.currentConversationId = action.payload;
    },
    clearCurrentConversationId: (state) => {
      state.currentConversationId = null;
    },
    setConversationList: (state, action: PayloadAction<ConversationInfo[]>) => {
      state.conversationList = action.payload;
      state.conversationListLoaded = true;
    },
    clearConversationList: (state) => {
      state.conversationList = [];
      state.conversationListLoaded = false;
    },
  },
});

export const {
  setCurrentConversationId,
  clearCurrentConversationId,
  setConversationList,
  clearConversationList,
} = conversationsSlice.actions;
export default conversationsSlice.reducer;
